import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const ThreeDotMenu = ({ menuItems, uniqueKey }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			<IconButton onClick={handleClick}>
				<MoreVertIcon />
			</IconButton>
			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				{menuItems.map((item, index) => (
					<MenuItem
						key={index + uniqueKey}
						onClick={() => {
							if (typeof item.props.onClick === 'function') {
								item.props.onClick();
							}
							handleClose();
						}}
					>
						{item}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
};

ThreeDotMenu.propTypes = {
	menuItems: PropTypes.arrayOf(
		PropTypes.oneOfType([PropTypes.string, PropTypes.node])
	).isRequired,
	uniqueKey: PropTypes.string,
};

export default ThreeDotMenu;
